import React, { Component } from 'react'
import service from "../services";
//react dropdown select
// import Select from "react-dropdown-select";
import Select from 'react-select';
import SearchResults from 'react-filter-search';



let sub;
let timer = null;

// const cookies = new Cookies();
class HighlightDropdown extends Component {
    constructor(props) {
        super(props)
        this.apiServe = new service();
        this.state = {
            highLightData: "",
            FeaturedData: '',
            loadItem: '10'
        }

    }

    // event
    componentWillUnmount = () => {
        sub.unsubscribe();
        clearTimeout(timer);
    };

    getProfile = () => {
        this.apiServe.sendevent("user|getProfile", {});
    };
    getFeaturedHighlight = () => {

        this.apiServe.sendevent("homePage|featuredHighlight|getList", {
            "highlightType": ["News", "In The Press", "Stories"],
            "limit": this.loadItem,
            "page": 1
        });
    };
    getFeaturedHighlightTile = () => {
        // this.props.FeaturedhighLightData
        this.apiServe.sendevent("homePage|featuredHighlightTile|getList", {
            "limit": 10,
            "page": 1
        });
    };

    componentDidMount = () => {
        this.getFeaturedHighlight();
        this.getFeaturedHighlightTile();
       
        sub = this.apiServe.getevent().subscribe((response) => {
            switch (response.event) {
                case "user|getProfile":
                    if (response.error) {
                    } else {
                        if (localStorage.getItem("myLoginToken")) {
                            let userInfo = {
                                fname: response.data.fname,
                                lname: response.data.lname,
                                image: response.data.image,
                            };
                            localStorage.setItem("Header", JSON.stringify(userInfo));
                        }

                        this.setState({ Header: true });
                        this.forceUpdate();
                    }
                    break;
                case "homePage|featuredHighlight|getList":
                    if (response.error) {
                    } else {
                        this.setState({
                            highLightData: response.data,
                        })
                    }
                    break;
                case "homePage|featuredHighlightTile|getList":
                    if (response.error) {
                    } else {
                        this.setState({
                            FeaturedData: response.data,
                        })

                    }
                    break;
                default:
                    break;
            }
        });

        // let article = document.querySelectorAll('.check_row');
        // article.forEach((item, index) => {
        //     (index % 2 == 0) ?item.classList.add('odd'):item.classList.add('even')
        // });
    };

    genreOption = () => {
        var options = []
        this.state && this.state.highLightData && this.state.highLightData.docs.forEach(item => {
                options.push({ value: item._id, label: item.highlightTitle, type:item.highlightType })
            }
        )
        return options
    }

    disabledSeleted(val, selectId) {
        if(val.length > 0){
            return this.props.selectedDropbox(val, selectId);
        }
        
    }

    

    render() {

        const {
            highLightData,
            FeaturedData
        } = this.state;
  
        return (
            <>
                {/* first dropdown */}
                <div>
                    <div className="home_page_title_wpr highlight_feature">
                        <div className="title_header">
                            <p>Tile 1</p>
                        </div>
                        <div className="title_content">
                            <div className="field_row horizontal_field">
                                <div className="field_row_inner">
                                    <label>Highlight</label>
                                    <div className="relative custom_dropdown">
                                        <div className="select_field relative ">
                                            {/* <Select
                                                options={highLightData && highLightData?.docs}
                                                itemRenderer={({ item, methods }) => (
                                                    <>
                                                        
                                                        {item?.disabled ? (
                                                            <div aria-disabled>{item?.label}</div>
                                                        ) : (
                                                                <div onClick={() => methods?.addItem(item)} className="check_row  d_flex relative">
                                                                    <h4 className="check_desc">{item?.highlightTitle}</h4>
                                                                    <p className="check_category">{item?.highlightType}</p>
                                                                </div>
                                                            )}
                                                    </>
                                                )}
                                                searchBy={'highlightTitle'}
                                                labelField={'highlightTitle'}
                                                valueField={'_id'}
                                                values={[FeaturedData && FeaturedData?.highlightFeaturedTile[0]?.featuredHighlightId]}
                                                placeholder={this.state.selectedHighligths}
                                                onChange={(value) => this.disabledSeleted(value, 0)}
                                            /> */}
                                            
                                            <Select
                                                value={this.props.selectedVal[0] }
                                                options={this.genreOption()}
                                                getOptionLabel={(option) => `${option.label} : ${option.type}`}
                                                onChange={(value) => this.props.handleChangeTile(value,0)}
                                            />
                                            {/* <Select
                                                defaultValue={FeaturedData && FeaturedData?.highlightFeaturedTile[0]?.featuredHighlightId._id}
                                                isClearable
                                                isSearchable
                                                name="color"
                                                options={highLightData && highLightData?.docs}
                                                // getOptionLabel={(option) => `${option.highlightTitle}: ${option.highlightType}`}
                                                getOptionLabel={(option) => (
                                                    <div className="check_row d_flex relative w_100">
                                                        <h4 className="check_desc">{option?.highlightTitle}</h4>
                                                        <p className="check_category">{option?.highlightType}</p>
                                                    </div>
                                                )
                                                }
                                                onChange={(value) => this.disabledSeleted(value, 0)}
                                            /> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* sec dropdown */}
                <div>
                    <div className="home_page_title_wpr highlight_feature">
                        <div className="title_header">
                            <p>Tile 2</p>
                        </div>
                        <div className="title_content">
                            <div className="field_row horizontal_field">
                                <div className="field_row_inner">
                                    <label>Highlight</label>
                                    <div className="relative custom_dropdown">
                                        <div className="select_field relative" >
                                            {/* <Select
                                                options={highLightData && highLightData?.docs}
                                                values={[]}
                                                itemRenderer={({ item, methods }) => {
                                                    return(
                                                        <>
                                                        {item?.disabled ? (
                                                            <div aria-disabled>{item?.label}</div>
                                                        ) : (
                                                                <div onClick={() => methods.addItem(item)} className="check_row d_flex relative">
                                                                    <h4 className="check_desc">{item?.highlightTitle}</h4>
                                                                    <p className="check_category">{item?.highlightType}</p>
                                                                </div>
                                                            )}
                                                        </>
                                                    )
                                                }}
                                                searchBy={'highlightTitle'}
                                                labelField={'highlightTitle'}
                                                valueField={'_id'}
                                                values={[FeaturedData && FeaturedData?.highlightFeaturedTile?.[1]?.featuredHighlightId]}
                                                placeholder={this.state.selectedHighligths}
                                                onChange={(value) => this.disabledSeleted(value, 1)}
                                            /> */}
                                            <Select
                                                value={this.props.selectedVal[1] }
                                                options={this.genreOption()}
                                                getOptionLabel={(option) => `${option.label} : ${option.type}`}
                                                onChange={(value) => this.props.handleChangeTile(value,1)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* three dropdown */}
                <div>
                    <div className="home_page_title_wpr highlight_feature">
                        <div className="title_header">
                            <p>Tile 3</p>
                        </div>
                        <div className="title_content">
                            <div className="field_row horizontal_field">
                                <div className="field_row_inner">
                                    <label>Highlight</label>
                                    <div className="relative custom_dropdown">
                                        <div className="select_field relative" >
                                            {/* <Select
                                                options={highLightData && highLightData?.docs}
                                                values={[]}
                                                itemRenderer={({ item, methods }) => (
                                                    <>
                                                        {item?.disabled ? (
                                                            <div aria-disabled>{item?.label}</div>
                                                        ) : (
                                                                <div onClick={() => methods.addItem(item)} className="check_row d_flex relative">
                                                                    <h4 className="check_desc">{item?.highlightTitle}</h4>
                                                                    <p className="check_category">{item?.highlightType}</p>
                                                                </div>
                                                            )}
                                                    </>
                                                )}
                                                searchBy={'highlightTitle'}
                                                labelField={'highlightTitle'}
                                                valueField={'_id'}
                                                values={[FeaturedData && FeaturedData?.highlightFeaturedTile[2]?.featuredHighlightId]}
                                                placeholder={this.state.selectedHighligths}
                                                onChange={(value) => this.disabledSeleted(value, 2)}
                                            /> */}
                                            <Select
                                                value={this.props.selectedVal[2] }
                                                options={this.genreOption()}
                                                getOptionLabel={(option) => `${option.label} : ${option.type}`}
                                                onChange={(value) => this.props.handleChangeTile(value,2)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* foure dropdown */}
                <div>
                    <div className="home_page_title_wpr highlight_feature">
                        <div className="title_header">
                            <p>Tile 4</p>
                        </div>
                        <div className="title_content">
                            <div className="field_row horizontal_field">
                                <div className="field_row_inner">
                                    <label>Highlight</label>
                                    <div className="relative custom_dropdown">
                                        <div className="select_field relative" >
                                            {/* <Select
                                                options={highLightData && highLightData.docs}
                                                values={[]}
                                                itemRenderer={({ item, methods }) => (
                                                    <>
                                                        {item?.disabled ? (
                                                            <div aria-disabled>{item?.label}</div>
                                                        ) : (
                                                                <div onClick={() => methods.addItem(item)} className="check_row d_flex relative">
                                                                    <h4 className="check_desc">{item?.highlightTitle}</h4>
                                                                    <p className="check_category">{item?.highlightType}</p>
                                                                </div>
                                                            )}
                                                    </>
                                                )}
                                                searchBy={'highlightTitle'}
                                                labelField={'highlightTitle'}
                                                valueField={'_id'}
                                                values={[FeaturedData && FeaturedData?.highlightFeaturedTile[3]?.featuredHighlightId]}
                                                placeholder={this.state.selectedHighligths}
                                                onChange={(value) => this.disabledSeleted(value, 3)}
                                            /> */}
                                            <Select
                                                value={this.props.selectedVal[3] }
                                                options={this.genreOption()}
                                                getOptionLabel={(option) => `${option.label} : ${option.type}`}
                                                onChange={(value) => this.props.handleChangeTile(value,3)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default HighlightDropdown;